if (typeof Countdown === 'undefined') {
  class Countdown extends HTMLElement {
    constructor() {
      super();

      const _this = this;

      if (!!Date.parse(_this.attributes.end.value)) {
        this.clock(_this, _this.attributes.end.value);
      }
    }

    clock(el, endtime) {
      const numberElements = el.querySelector('[countdown-numbers]');
      numberElements.style.visibility = 'hidden';
      numberElements.innerHTML = el.querySelector('template[timer]').innerHTML;

      const daysEl = numberElements.querySelector('[countdown-days]');
      const hoursEl = numberElements.querySelector('[countdown-hours]');
      const minutesEl = numberElements.querySelector('[countdown-minutes]');
      const secondsEl = numberElements.querySelector('[countdown-seconds]');

      const timeinterval = setInterval(() => {
        const t = this.tick(endtime);

        if (t.total > 0) {
          if (daysEl.innerText !== t.days) daysEl.innerText = t.days;
          if (hoursEl.innerText !== t.hours) hoursEl.innerText = t.hours;
          if (minutesEl.innerText !== t.minutes) minutesEl.innerText = t.minutes;
          if (secondsEl.innerText !== t.seconds) secondsEl.innerText = t.seconds;
          numberElements.style.visibility = '';
        } else {
          clearInterval(timeinterval);
          const completeMessage = el.querySelector('[countdown-complete-message]');
          if (completeMessage) {
            completeMessage.style.display = 'block';
            el.querySelector('[countdown-numbers]').style.display = 'none';
          }
        }
      }, 1000);
    }

    tick(endtime) {
      const current_time = {
        total: Date.parse(endtime) - Date.parse(new Date()),
        seconds: '00',
        minutes: '00',
        hours: '00',
        days: '00',
      };

      current_time.seconds = Math.floor((current_time.total / 1000) % 60);
      current_time.minutes = Math.floor((current_time.total / (1000 * 60)) % 60);
      current_time.hours = Math.floor((current_time.total / (1000 * 60 * 60)) % 24);
      current_time.days = Math.floor(current_time.total / (1000 * 60 * 60 * 24));

      // Format values to have leading zeros
      Object.keys(current_time).forEach((key) => {
        if (typeof current_time[key] === 'number') {
          current_time[key] =
            current_time[key] < 10 && current_time[key] >= 0 ? '0' + current_time[key] : current_time[key].toString();
        }
      });

      return current_time;
    }
  }

  ['DOMContentLoaded', 'shopify:section:load', 'shopify:section:select', 'shopify:section:reorder', 'shopify:block:select'].forEach(
    (event) => {
      document.addEventListener(event, () => {
        if (!customElements.get('count-down')) customElements.define('count-down', Countdown);
      });
    },
  );

}